/**
 * <video-feature> — click-to-play poster facade. Shows the cover image with a
 * play button; on click it swaps in the real video/embed (which autoplays).
 * No-ops when there's no poster trigger (video renders directly). No imports.
 */
class VideoFeature extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-vf-trigger]');
    this.template = this.querySelector('[data-vf-content]');
    if (this.trigger && this.template) {
      this.trigger.addEventListener('click', this.#reveal, { once: true });
    }
  }

  #reveal = () => {
    const content = this.template.content.cloneNode(true);
    this.trigger.remove();
    this.template.remove();
    this.appendChild(content);
    const video = this.querySelector('video');
    if (video && typeof video.play === 'function') {
      video.play().catch(() => {});
    }
  };
}

if (!customElements.get('video-feature')) {
  customElements.define('video-feature', VideoFeature);
}
